export enum SkipInterception {
  SKIP_INTERCEPTOR = 'skipInterceptor',
  UNKNOWN_IDENTIFIER_ERROR = 'UnknownIdentifierError',
}
